import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/visaInfo', request)
}

export {get}
